/*
 * @Author: your name
 * @Date: 2021-05-17 09:29:53
 * @LastEditTime: 2022-01-06 09:42:45
 * @LastEditors: Smart Chow
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/apps/modules/00_sample/moduleDefine.js
 */
/* BasicLayout */
import BasicLayout from '@/frameworks/layouts/BasicLayout'
import { dynamicWrapper } from '@/common/utils/routerComponentWrapper.js'

const routerComponents = {
  sampleMain: () =>
    import(/* webpackChunkName: "00-sample" */ './sampleMain.vue')
}

export default {
  // 模块子路由表
  routes: [
    {
      path: '/config',
      component: BasicLayout,
      meta: {
        title: '设置',
        icon: 'chart'
      },
      children: [
        {
          path: 'sample',
          component: dynamicWrapper(['00_sample'], routerComponents.sampleMain),
          meta: { title: '示例测试', noCache: true }
        }
      ]
    }
  ]
}
